import React, { memo } from 'react';

import {
  ThemeProvider as MuiThemeProvider,
  ThemeProviderProps as MuiThemeProviderProps,
} from '@mui/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { getDateFnsLocale } from '@helpers/date/getDateFnsLocale';
import { useTranslation } from '@helpers/internationalization/useTranslation';

interface ThemeProviderProps extends MuiThemeProviderProps {}

export const ThemeProvider = memo((props: ThemeProviderProps) => {
  // this trick is used to reload LocalizationProvider when user change language
  const {
    i18n: { language: _language },
  } = useTranslation();

  return (
    <LocalizationProvider
      adapterLocale={getDateFnsLocale()}
      // @ts-ignore -- This error is caused by the differencies between the versions of the two libraries
      dateAdapter={AdapterDateFns}>
      <MuiThemeProvider {...props} />
    </LocalizationProvider>
  );
});
